export const formatCurrencyCompact = (value: number, lang: string): string => {
  if (value >= 10000000) {
    return `10 ${lang === 'vi' ? 'triệu' : 'mil'}+`;
  }
  if (value >= 1000000) {
    const millions = Math.floor(value / 1000000);
    return `${millions} ${lang === 'vi' ? 'triệu' : 'mil'}+`;
  }
  if (value >= 1000) {
    const roundedValue = Math.round(value / 100) * 100;
    const thousands = (roundedValue / 1000).toFixed(1);
    if (thousands.endsWith('.0')) {
      return `${parseInt(thousands)}k`;
    }
    return `${thousands}k`;
  }
  if (Math.round(value) === 1000) {
    return `1k`;
  }
  return `${Math.round(value)}`;
};
